import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import { SR_BUTTON_THEME_ADOBE_GREY } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrInstructionsText from 'client/components/SrInstructionsText/SrInstructionsText';

import './SrPartnerSupraLockboxInstructionsModal.less';

const SrPartnerSupraLockboxInstructionsModal = ({
  onClose,
  supraLockboxPhotoUrl,
  sunlockInstalled,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
      buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
      onClose={onClose}
      contentPadding='26px 20px 260px'
    >
      <SrBox styleName='SrPartnerSupraLockboxInstructionsModal'>
        <SrBox paddingRight='48px'>
          <SrText
            size='30'
            lineHeight='36px'
            display='block'
            weight='800'
          >
            Supra Lockbox Instructions
          </SrText>
        </SrBox>
        <SrBox marginTop='8px'>
          <SrText
            opacity='0.6'
          >
            We also installed a Supra lockbox at the property. More tours from agents!
          </SrText>
        </SrBox>
        {supraLockboxPhotoUrl &&
        <>
          <SrBox marginTop='32px'>
            <img
              width={isSmallScreen ? '100%' : '450px'}
              height='auto'
              alt='sunlock'
              src={supraLockboxPhotoUrl}
              style={{ borderRadius: '14px' }}
            />
          </SrBox>
          <SrBox marginTop='8px'>
            <SrText
              opacity='0.6'
              fontStyle='italic'
            >
              Photo: The Supra lockbox installed at your property.
            </SrText>
          </SrBox>
        </>
        }
        {!supraLockboxPhotoUrl &&
        <SrFlex width='100%' justify='center' marginTop='35px'>
          <SrFlex
            backgroundColor='rgba(77, 106, 133, 0.15)'
            width='58px'
            height='65px'
            borderRadius='14px'
            align='center'
            justify='center'
            flexShrink='0'
          >
            <img
              alt='lock icon'
              src='/images/supra-lock-icon.svg'
              height='auto'
              style={{
                filter:
                'drop-shadow(3px 4px 11px rgba(168, 135, 0, 0.18))',
              }}
            />
          </SrFlex>
        </SrFlex>
        }
        <SrBox marginTop='16px'>
          <SrInstructionsText instructions={sunlockInstalled
            ? (
              'The Supra will be used by licensed real estate agents to access ' +
              'the home for property tours. Inside the Supra is one physical key ' +
              'to open the Sunlock. Supra lockboxes are commonly used in ' +
              'the real estate industry as a secure way for licensed agents to tour ' +
              'homes and for Sunroom to track those tours.'
            )
            : (
              'The Supra will be used by licensed real estate agents to access ' +
              'the home for property tours. Inside the Supra is one physical key ' +
              'to open the door. Supra lockboxes are commonly used in ' +
              'the real estate industry as a secure way for licensed agents to tour ' +
              'homes and for Sunroom to track those tours.'
            )
          }
          />
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrPartnerSupraLockboxInstructionsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  supraLockboxPhotoUrl: PropTypes.string.isRequired,
  sunlockInstalled: PropTypes.bool,
};

SrPartnerSupraLockboxInstructionsModal.displayName = 'SrPartnerSupraLockboxInstructionsModal';

export default SrPartnerSupraLockboxInstructionsModal;
